import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { any, bool, func } from 'prop-types'

import { authenticationMessages } from '../../../translations'
import { useFormContext } from '../../Form'
import { EmailInput, PasswordInput, PasswordConfirmationInput, Recaptcha } from '../Inputs'
import { SubmitButton } from '../SubmitButton'
import { TermsOfService } from './TermsOfService'

const StyledButtonWrapper = styled.div`
  text-align: center;
  margin: 1.25rem 0;
`

const StyledSubmitButton = styled(SubmitButton)`
  margin-top: 1rem;
`

export const SignUpInputs = ({ clearCaptcha, setClearCaptcha, signUpErrors }) => {
  const { formatMessage } = useIntl()
  const { setFieldValue, values, errors, isSubmitting, setSubmitting } = useFormContext()
  const captchaRef = useRef()

  useEffect(() => {
    if (clearCaptcha) {
      setFieldValue('captcha', null)
      setClearCaptcha(false)
    }
  }, [clearCaptcha, values, errors])

  useEffect(() => {
    if (isSubmitting && (errors || signUpErrors)) {
      setSubmitting(false)
      captchaRef.current.reset()
    }
  }, [signUpErrors])

  const handleCaptcha = (value) => {
    setFieldValue('captcha', value)
  }

  return (
    <>
      <EmailInput />
      <PasswordInput showValidations />
      <PasswordConfirmationInput />
      <TermsOfService />
      <StyledButtonWrapper>
        <Recaptcha handleCaptcha={handleCaptcha} setRef={captchaRef} />
        <StyledSubmitButton checkCaptcha>
          {formatMessage(authenticationMessages.createAccount)}
        </StyledSubmitButton>
      </StyledButtonWrapper>
    </>
  )
}

SignUpInputs.propTypes = {
  clearCaptcha: bool,
  setClearCaptcha: func,
  signUpErrors: any,
}
